export default __webpack_public_path__ + "static/47640a53f32cedb5e7e1efc417a4b2ee.png";